import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/contact")({
  component: Contact,
  head: () =>
    pageHead({
      title: "Contact jaik | Seattle Contractor Web Design",
      description: "Get in touch with jaik for a free contractor website mockup. Seattle-based web designer serving King County contractors. Call (253) 293-1550.",
      path: "/contact",
    }),
});
